var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoIngestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FEF0E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "url(#pattern0_7701_10124)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7701_10124",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7701_10124",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7701_10124",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAACVElEQVR4nO1WsW7UQBBdpPNMLoG0oFREggIQgoYAH0ATajokpHCZgSPpCXxDSDj4AyqKkDriK9CBEC1JB0KCnHd9ArRonN3Ed7IV2+srkPKk1fm8np0382bGVuoEJ8iBYbSTWOq/IaAZPzqjLavUKVUTYitnyFlyZmlD08F5Q/A9NSR4VpeAZnieBkL4w3TxQiVjw3hHM/7RhH8TgrtVnYfap5Do60QwkkGGNRWkIeFbp+Fnu6pmj7XpqtOasO9qaDukhiofWIdwKRjG82VSWley6kXFsFh1vxFohrW8CEcyRPBUTQo2o3HuInwXXHRlirKIgOwlj+GSZnypCT9pxlgzDtxk3Rh2oiuqCZix2Z4hsSE1UEQwrRGGnr2nYFIErGY0mnAz5taCva9mZMXUvumykrhOeh9EwhQRIPg6pOhqkd2Qo2uGYdeR6DVCQHT1kXvnhvDJoDt9zj8v13LPk5BMiBwJw+VgAprhtdff7a34SSiOZcm1e2bF2fRc17wIJ+DGdLzcuuGj9Q7lN3vtsyI1cTAzsB9EwDAuSyp9C/r9sahHnAvskjrj7v8KJTAyA/z+/sOZs5mvKnH0JV5qzx0SWFWzLgM/gwjIAYbhWyoBtxZKS/CofStYAk34IWG46AtK+rx0ERK8cv/XaxKAN5bUtG9DmX7SWtJix7XhoBNd14zDoDYcx1FEsOtJ5EGcG4I9l8HNoucqwz5QU5phxx2ciCyisxTmwRfV1G0hKZEfjmJSUWMEjkik8774ZUT4WyJv3HkWmddxP30VE+67YbWep/k/sOffDGcfrHwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIngestionIcon);
export default __webpack_public_path__ + "static/media/NoIngestionIcon.0c8699688ac7aabb0e941b1dbf4b952c.svg";
export { ForwardRef as ReactComponent };